import { PopoverTrigger } from '@chakra-ui/react'

export default PopoverTrigger
